import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-kompetenzen',
  templateUrl: './kompetenzen.component.html',
  styleUrls: ['./kompetenzen.component.scss']
})
export class KompetenzenComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
